<script setup lang="ts">
import merge from 'lodash-es/merge';
import ElearningPageSelector from '~~/layers/elearning/app/components/edito/ElearningPageSelector.vue';

defineOptions({
    name: 'WidgetNotificationsSettings'
});

interface FormSettings
{
    settings: any;
}

const emit = defineEmits<{
    (e: 'update:modelValue', payload: any): void;
}>();

const props = defineProps<{
    modelValue: any;
}>();

const { $t } = useLocalization();

const module = ref<string>('cmb_account');
const defaults = ref<any>({
    page: null
});

const form = computed<FormType<FormSettings>>(() =>
{
    return props.modelValue;
});

const pageId = computed({
    get(): number | null
    {
        const page = form.value.settings?.page;
        return page ? parseInt(page, 10) : null;
    },
    set(value: number | null): void
    {
        form.value.settings.page = value ? value.toString() : null;
        triggerModel();
    }
});

function triggerModel(): void
{
    emit('update:modelValue', form.value);
}

async function validate(): Promise<void>
{
    form.value.validate(schema => ({
        settings: schema.object({
            page: schema.string().nullable().required($t('[[[Wybranie strony jest wymagane]]]'))
        })
    }));
}

watch(() => form.value.settings, () =>
{
    triggerModel();
}, { deep: true });

onBeforeMount(async (): Promise<void> =>
{
    form.value.settings = merge(defaults.value, form.value.settings);
});

defineExpose({
    validate
});
</script>

<template>
    <IdeoFormGroup :label="$t('[[[Strona z modułu konto użytkownika]]]')" :invalid-feedback="form.$errors.first('settings.page')" :state="form.$errors.state('settings.page')" required>
        <ElearningPageSelector
            v-model="pageId"
            :module="module"
            label=""
            :website-id="form.websiteId"
            :locale="form.locale"
            class="mb-0"
        />
    </IdeoFormGroup>
</template>
